module.exports = __webpack_public_path__ + "img/users.0247aeec.svg";